const ShortcutListing = (props) => {
  return null;
};

export default ShortcutListing;
